export class BankAccountDetails {
	private bank_name: string = "";
	private bic: string = "";
	private holder: string = "";
	private iban: string = "";
	private country_id: string = "";

	public getBankName(): string {
		return this.bank_name;
	}

	public setBankName(s: string): void {
		this.bank_name = s;
	}

	public getBic(): string {
		return this.bic;
	}

	public setBic(s: string): void {
		this.bic = s;
	}

	public getHolder(): string {
		return this.holder;
	}

	public setHolder(s: string): void {
		this.holder = s;
	}

	public getIban(): string {
		return this.iban;
	}

	public setIban(s: string): void {
		this.iban = s;
	}

	public getCountryId(): string {
		return this.country_id;
	}

	public setCountryId(s: string): void {
		this.country_id = s;
	}

	public get hasDetails(): boolean {
		return this.bank_name !== "" && this.bic !== "" && this.holder !== "" && this.iban !== "";
	}
}
